export class AzureSourceAccountAttributes {
    'tenantId';
    'subscriptionId';
    'resourceGroupName';
    'eonInternalResourceGroupName';
    'managementGroupId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonInternalResourceGroupName",
            "baseName": "eonInternalResourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementGroupId",
            "baseName": "managementGroupId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
